package app.nestbridge.feature.children.api.model

import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class ChildDto(
    val id: String,
    val fullName: String,
    val displayName: String? = null,
    val dateOfBirth: LocalDate,
    val primaryLanguages: List<String> = emptyList(),
    val stewardUserIds: List<String> = emptyList(),
    val profilePictureUrl: String? = null,
    val status: ChildStatusDto,
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
)

@Serializable
enum class ChildStatusDto {
    ACTIVE,
    SUSPENDED,
    ARCHIVED,
}
